import apiServiceCall from "../services/ApiServiceCall";

export const getPolicyAndPrivacyData = () => {
  return apiServiceCall().get('/vui/frontend/pages/politica-privacidad').then(({ data }) => data);
}

// Alias para compatibilidad con código existente
export const getPolicyAndPrivacyDataFromWordpress = getPolicyAndPrivacyData;